export const AdminStatus = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  SUSPENDED: 'suspended',
};

export const TwoFactorAuthStatus = {
  ENABLED: 'true',
  DISABLED: 'false',
};
